import { z } from 'zod';

const objectId = z.string().regex(/^[a-f\d]{24}$/i, 'Invalid id');

export const PRIVACY_NOTICE_TYPES = [
    'genel', 'calisan', 'musteri', 'ziyaretci', 'kamera', 'web_sitesi', 'cerez', 'tedarikci', 'diger',
];

export const PRIVACY_NOTICE_CHANNELS = ['fiziksel', 'web', 'eposta', 'tabela', 'sozlu', 'mobil'];

export const PRIVACY_NOTICE_STATUSES = ['draft', 'in_review', 'published', 'archived'];

export const PRIVACY_NOTICE_ELEMENT_KEYS = [
    'controllerIdentity',
    'processingPurposes',
    'recipientsAndPurpose',
    'collectionMethodAndLegalReason',
    'dataSubjectRights',
];

export const PrivacyNoticeSchema = z.object({
    id: z.string().optional(),
    code: z.string().trim().max(120).optional().or(z.literal('')),
    title: z.string().min(1),
    description: z.string().optional(),
    noticeType: z.enum(PRIVACY_NOTICE_TYPES).optional(),
    channels: z.array(z.enum(PRIVACY_NOTICE_CHANNELS)).optional(),
    language: z.enum(['tr', 'en']).optional(),
    body: z.string().optional(),
    linkedProcessingActivities: z.array(objectId).optional(),
    linkedInventoryItems: z.array(objectId).optional(),
    confirmedElements: z.array(z.enum(PRIVACY_NOTICE_ELEMENT_KEYS)).optional(),
    effectiveDate: z.string().or(z.date()).optional(),
    status: z.enum(PRIVACY_NOTICE_STATUSES).optional(),
    customFields: z.record(z.any()).optional(),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});

export const CreatePrivacyNoticeSchema = PrivacyNoticeSchema.omit({ id: true, createdAt: true, updatedAt: true, status: true });
export const UpdatePrivacyNoticeSchema = PrivacyNoticeSchema.omit({ id: true, createdAt: true, updatedAt: true }).partial();
